<template>
  <div class="request-content">
    <div class="request-content-info">
      <div class="request-content-info-l">
        <div style="line-height:50px;font-weight:bold;color:#1a1a1a;background-color:#fafafa">体验产品</div>
        <div v-if="proList.items && proList.items.length" style="height:821px;overflow:auto">
          <Row
            v-for="(item,index) in proList.items"
            :key="index"
            class="row-title"
            :class="{rowtitle:index==current}"
            @click.native="getApplyId(item,index)"
          >
            <Col style="height: 30%;text-overflow:ellipsis;">{{ item.name }}</Col>
            <!-- <Col style="height: 30%;font-size: 12px;color:#f00;" v-if="!item.isApply">未开启报名</Col> -->
            <Col 
            style="height: 30%;font-size: 12px;color:blue;" 
            v-if="new Date().getTime() < new Date(item.applyStart).getTime()">
            体验于{{ new Date(item.applyStart).getFullYear() }}/{{ (new Date(item.applyStart).getMonth() + 1) }}/{{ new Date(item.applyStart).getDate() }}开启   
            </Col>
            <Col style="height: 30%;font-size: 12px;color:#ffb200;" v-if="(new Date(item.applyStart).getTime() < new Date().getTime()) && (new Date(item.applyEnd).getTime() > new Date().getTime())">剩余: {{ item.applyEnd | time_sort }}</Col>
            <Col
              style="height: 30%;font-size: 12px;color:#b5b5b5"
              v-if="new Date().getTime() > new Date(item.applyEnd).getTime()"
            >报名截止于{{ new Date(item.applyEnd).getFullYear() }}/{{ (new Date(item.applyEnd).getMonth() + 1) }}/{{ new Date(item.applyEnd).getDate() }}</Col>

            <Col style="height: 30%">共 {{ item.applyCount }} 条申请记录</Col>
          </Row>
        </div>
        <div v-else style="text-align:center;margin-top:50px;">暂无体验产品</div>
      </div>
      <div class="request-content-info-r">
        <Row
          style="text-align:center;line-height:50px;height:50px;color:#1a1a1a;font-weight:bold;padding-left:30px;background-color:#fafafa"
        >
          <Col span="4">姓名</Col>
          <Col span="3">手机</Col>
          <Col span="6">公司</Col>
          <Col span="8">地址</Col>
          <Col span="3">操作</Col>
        </Row>
        <Row v-if="applyList.items && applyList.items.length">
          <div style="height:690px;overflow:auto;margin-left:30px">
            <div class="info-list" v-for="(item,index) in applyList.items" :key="index">
              <Row style="text-align:center;min-height:60px;display:flex;align-items:center">
                <Col span="4">{{ item.name }}</Col>
                <Col span="3">{{ item.mob }}</Col>
                <Col span="6">{{ item.company }}</Col>
                <Col span="8">{{ item.address }}</Col>
                <Col span="3" style="display:flex;justify-content:space-around;">
                  <i
                    class="icon iconfont icon-guanbi"
                    :class="item.auditState === 0 ? 'auditState1' : 'auditState2' "
                    style="font-size:30px;"
                  ></i>
                </Col>
              </Row>
            </div>
          </div>
          <div class="my-page" v-if="totalCount > pageSize">
            <Page
              show-total
              show-elevator
              :page-size="pageSize"
              :current="pageIndex"
              :total="totalCount"
              @on-change="changePage"
              @on-page-size-change="changePageSize"
            />
          </div>
        </Row>
        <div v-else style="text-align:center;margin-top:50px;">暂无体验申请</div>
        <div class="total">已报名 {{ applyCount }} / {{ applyMaxCount }} 人</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  // 产品体验
  name: "feedback-request",
  data() {
    return {
      proList: "",
      prototlaCount: "",
      applyList: [],
      applyId: "",
      applyCount: "",
      applyMaxCount: "",
      current: 0,
      timer: "",
      endTime: true,
      arr: [],

      pageSize: 10,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      user: "getUser"
    })
  },
  methods: {
    ...mapActions({
      getProduct: "productFeedbackModule/getProduct",
      getProductApply: "productFeedbackModule/getProductApply"
    }),
    getApplyId(id, index) {
      this.applyId = id.id;
      this.current = index;
      this.init();
    },
    async init() {
      let proList = await this.getProduct({ CompId: this.company.id });
      let proList2 = await this.getProduct({
        CompId: this.company.id,
        pageSize: proList.totalCount
      });
      let proList3 = {
        items: []
      };
      proList3.items = proList2.items.filter(a => {
        return a.isApply === true;
      })
      this.proList = proList3;
      if (this.proList && this.proList.items && this.proList.items.length === 0) return;

      // 按照报名时间排序
      this.getTime(this.proList.items);
      let arr1 = this.proList.items.filter(a => {
        return a.applyEnd > new Date().getTime();
      });
      arr1.sort(this.sortNum2);
      let arr2 = this.proList.items.filter(a => {
        return a.applyEnd <= new Date().getTime();
      });
      this.proList.items = arr1.concat(arr2);
      // 报名列表
      let option = {
        By: this.applyId || this.proList.items[0].id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
      this.applyList = await this.getProductApply(option);
      if (this.applyList.items) {
        this.pageSize = this.applyList.pageSize;
        this.pageIndex = this.applyList.pageIndex;
        this.totalCount = this.applyList.totalCount;
      }
      let Num = this.myFilter(
        this.proList.items,
        this.applyId || this.proList.items[0].id
      );
      this.applyCount = Num[0].applyCount;
      this.applyMaxCount = Num[0].applyMaxCount;
      this.cutTime(this.proList.items);
    },
    sortNum2(a, b) {
      return a.applyEnd - b.applyEnd;
    },
    getTime(arr) {
      function sortNum1(a, b) {
        return b.applyEnd - a.applyEnd;
      }
      arr.map(a => {
        a.applyEnd = new Date(a.applyEnd).getTime();
      });
      return arr.sort(sortNum1);
    },
    cutTime(arr) {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        arr.map(c => {
          let last = new Date(c.applyEnd).getTime() - 100;
          if (new Date(c.applyEnd).getTime() > new Date().getTime()) {
            c.applyEnd = last;
          } else {
            c.applyEnd = c.applyEnd;
          }
        });
      }, 1000);
    },
    myFilter(arr, id) {
      return arr.filter(ele => ele.id === id);
    },
    // exportInfo() {
    //   if (!(this.applyList.items && this.applyList.items.length)) {
    //     return;
    //   }
    //   const exData = this.transformData(this.applyList.items);
    //   require.ensure([], () => {
    //     const {
    //       export_json_to_excel
    //     } = require("../../../../../../../assets/js/Export2Excel"); //这个地址和页面的位置相关，这个地址是Export2Excel.js相对于页面的相对位置
    //     const tHeader = ["姓名", "手机", "公司", "地址"]; //这个是表头名称 可以是iveiw表格中表头属性的title的数组
    //     const filterVal = ["name", "mob", "company", "address"]; //与表格数据配合 可以是iview表格中的key的数组
    //     const data = this.formatJson(filterVal, exData);
    //     export_json_to_excel(tHeader, data, "体验申请"); //列表excel  这个是导出表单的名称
    //   });
    // },
    transformData(data) {
      // 转换数据
      let arr = [];
      data.forEach(c => {
        arr.push({
          name: c.name,
          mob: c.mob,
          company: c.company,
          address: c.address
        });
      });
      return arr;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    }
  },
  changePage(e) {
    this.pageIndex = e;
    this.init();
  },
  changePageSize(e) {
    this.pageSize = e;
    this.init();
  },
  mounted() {
    this.init();
  }
};
</script>

<style scoped lang="scss">
.request-content {
  min-width: 800px;
  background-color: #f0f2f5;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 30px 30px 0 30px;
  &-info {
    width: 100%;
    height: 871px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 0px rgba(15, 17, 20, 0.2);
    padding-right: 30px;
    display: flex;
    &-l {
      width: 230px;
      text-align: center;
    }
    &-r {
      flex: 1;
      position: relative;
    }
    .row-title {
      background-color: #f2f2f2;
      border-bottom: 1px solid #e8e8e8;
      padding: 10px 0 10px 15px;
      text-align: left;
      &:hover {
        background-color: #fff;
        cursor: pointer;
      }
    }
    .rowtitle {
      background-color: #fff;
      border-bottom: 1px solid #e8e8e8;
      padding: 10px 0 10px 15px;
      &:hover {
        cursor: pointer;
      }
    }
  }
}
.total {
  position: absolute;
  height: 55px;
  bottom: 0;
  left: 6%;
  line-height: 50px;
}
.info-time {
  font-size: 12px;
  color: #ffb200;
}
.info-list {
  border-bottom: 1px solid #e8e8e8;
  &:hover {
    background-color: #f2f2f2;
  }
}
.auditState1 {
  font-size: 30px;
  cursor: pointer;
  color: #ff0000;
}
.auditState2 {
  font-size: 30px;
  cursor: pointer;
}
.my-page {
  height: 80px;
  padding: 25px 0 0 50px;
}
</style>
